<template>
	<div class="wrap">
		<div class="container">
			<!-- <div class="returns" @click="$router.back()">返回</div> -->
            <van-field v-model="exchange_code" center clearable placeholder="输入优惠券兑换码" >
                <template #button>
                    <van-button size="small" type="primary" @click="exchangeCode">兑换</van-button>
                </template>
            </van-field>
			<div class="voucher">
				<van-tabs v-model="voucher" @click="showCoupon($event)">
					<van-tab title="全部" name="all" >
						<div class="voucher_wrap">
							<ul class="f-clearfix">
								<van-list v-model="all_loading" loading-text="加载中..." :finished="all_finished" finished-text="" @load="getCouponList('all')">
									<li v-for="(value,index) in all_voucher" :key="index">
										<div class="coupon coupon-wave-left coupon-wave-right" :class="(value.used == 1 || value.expirationed == 1) ? 'coupon-no' : 'coupon-yes'">
											<van-col span="16" class="coupon-info coupon-hole coupon-info-right-dashed">
												<div class="coupon_price" v-if="value.type == 1">
													<div class="price_le"><span>$</span>{{Number(value.discount_price).toFixed(0)}}</div>
												</div>
												<div class="coupon_price" v-if="value.type == 2">
													<div class="price_le">{{value.discount_rate * 10}}</div>
													<div class="price_ri">
														<p>%</p>
														<p>OFF</p>
													</div>
												</div>
												<div class="coupon_time">到期时间: {{value.expiration_time_text}}</div>
											</van-col>
											<van-col span="8" class="coupon-get">
												<div class="coupon_status">
													<router-link class="coupon_but" :to="value.used == 1 ? '' : (value.expirationed == 1 ? '' : '/')">
														<van-button round size="small" block color="#fcbbd6" type="primary">{{value.used == 1 ? 'USED' : (value.expirationed == 1 ? '到期' : '立即使用')}}</van-button>
													</router-link>
													<p v-if="value.where_order_price > 0.00">结束 ￥{{value.where_order_price}}</p><p v-else>&nbsp;</p>
												</div>
											</van-col>
										</div>
									</li>
									<van-empty description="没有更多了..." v-if="all_voucher.length===0"/>
								</van-list>
							</ul>
						</div>
					</van-tab>
					<van-tab title="待使用" name="collected">
						<div class="voucher_wrap">
							<ul class="f-clearfix">
								<van-list v-model="collected_loading" loading-text="加载中..." :finished="collected_finished" finished-text="" @load="getCouponList('collected')">
									<li v-for="(value,index) in collected_voucher" :key="index">
										<div class="coupon coupon-wave-left coupon-wave-right" :class="(value.used == 1 || value.expirationed == 1) ? 'coupon-no' : 'coupon-yes'">
											<van-col span="16" class="coupon-info coupon-hole coupon-info-right-dashed">
												<div class="coupon_price" v-if="value.type == 1">
													<div class="price_le"><span>$</span>{{Number(value.discount_price).toFixed(0)}}</div>
												</div>
												<div class="coupon_price" v-if="value.type == 2">
													<div class="price_le">{{value.discount_rate * 10}}</div>
													<div class="price_ri">
														<p>%</p>
														<p>OFF</p>
													</div>
												</div>
												<div class="coupon_time">到期时间: {{value.expiration_time_text}}</div>
											</van-col>
											<van-col span="8" class="coupon-get">
												<div class="coupon_status">
													<div class="coupon_but">
														<van-button round size="small" block color="#fcbbd6" type="primary">{{value.used == 1 ? 'USED' : (value.expirationed == 1 ? '到期' : '立即使用')}}</van-button>
													</div>
													<p v-if="value.where_order_price > 0.00">结束 ￥{{value.where_order_price}}</p><p v-else>&nbsp;</p>
												</div>
											</van-col>
										</div>
									</li>
									<van-empty description="没有更多了..." v-if="collected_voucher.length===0"/>
								</van-list>
							</ul>
						</div>
					</van-tab>
					<van-tab title="已使用" name="used">
						<div class="voucher_wrap">
							<ul class="f-clearfix">
								<van-list v-model="used_loading" loading-text="加载中..." :finished="used_finished" finished-text="" @load="getCouponList('used')">
									<li v-for="(value,index) in used_voucher" :key="index">
										<div class="coupon coupon-wave-left coupon-wave-right" :class="(value.used == 1 || value.expirationed == 1) ? 'coupon-no' : 'coupon-yes'">
											<van-col span="16" class="coupon-info coupon-hole coupon-info-right-dashed">
												<div class="coupon_price" v-if="value.type == 1">
													<div class="price_le"><span>$</span>{{Number(value.discount_price).toFixed(0)}}</div>
												</div>
												<div class="coupon_price" v-if="value.type == 2">
													<div class="price_le">{{value.discount_rate * 10}}</div>
													<div class="price_ri">
														<p>%</p>
														<p>OFF</p>
													</div>
												</div>
												<div class="coupon_time">到期时间: {{value.expiration_time_text}}</div>
											</van-col>
											<van-col span="8" class="coupon-get">
												<div class="coupon_status">
													<div class="coupon_but">
														<van-button round size="small" block color="#fcbbd6" type="primary">{{value.used == 1 ? 'USED' : (value.expirationed == 1 ? '到期' : '立即使用')}}</van-button>
													</div>
													<p v-if="value.where_order_price > 0.00">结束 ￥{{value.where_order_price}}</p><p v-else>&nbsp;</p>
												</div>
											</van-col>
										</div>
									</li>
									<van-empty description="没有更多了..." v-if="used_voucher.length===0"/>
								</van-list>
							</ul>
						</div>

					</van-tab>
					<van-tab title="已过期" name="expired">
						<div class="voucher_wrap">
							<ul class="f-clearfix">
								<van-list v-model="expired_loading" loading-text="加载中..." :finished="expired_finished" finished-text="" @load="getCouponList('expired')">
									<li v-for="(value,index) in expired_voucher" :key="index">
										<div class="coupon coupon-wave-left coupon-wave-right" :class="(value.used == 1 || value.expirationed == 1) ? 'coupon-no' : 'coupon-yes'">
											<van-col span="16" class="coupon-info coupon-hole coupon-info-right-dashed">
												<div class="coupon_price" v-if="value.type == 1">
													<div class="price_le"><span>$</span>{{Number(value.discount_price).toFixed(0)}}</div>
												</div>
												<div class="coupon_price" v-if="value.type == 2">
													<div class="price_le">{{value.discount_rate * 10}}</div>
													<div class="price_ri">
														<p>%</p>
														<p>OFF</p>
													</div>
												</div>
												<div class="coupon_time">到期时间: {{value.expiration_time_text}}</div>
											</van-col>
											<van-col span="8" class="coupon-get">
												<div class="coupon_status">
													<div class="coupon_but">
														<van-button round size="small" block color="#fcbbd6" type="primary">{{value.used == 1 ? 'USED' : (value.expirationed == 1 ? '到期' : '立即使用')}}</van-button>
													</div>
													<p v-if="value.where_order_price > 0.00">结束 ￥{{value.where_order_price}}</p><p v-else>&nbsp;</p>
												</div>
											</van-col>
										</div>
									</li>
									<van-empty description="没有更多了..." v-if="expired_voucher.length===0"/>
								</van-list>
							</ul>
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</div>
        <coupons-box v-if="user_coupons.length > 0" :user_coupons="user_coupons" :source="'exchange'"></coupons-box>
		<v-foot></v-foot>
	</div>
</template>
<style scoped>
:deep(.van-tab--active){
    font-size: 17px;
    font-weight: 600;
}
:deep(.van-tabs__line){
    background:#fff;
}
.returns{
	/* padding: 20px; */
	width: 50px;
	height: 30px;
	border: 1px solid #ebedf0;
	font-size: 16px;
	color: #000;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 15px;
	border-radius: 4px;
}
</style>
<script>
	// @ is an alias to /src
    import couponsBox from './coupons_box.vue'
	export default {
		components: {
            couponsBox
        },
		created() {
			// this.getCouponList('all');
			this.getjiant()
		},
		data() {
			return {
				voucher: '1',
				all_voucher:[],
				collected_voucher: [],
				used_voucher: [],
				expired_voucher: [],
				all_finished: false,
				all_loading: false,
				collected_finished: false,
				collected_loading: false,
				used_finished: false,
				used_loading: false,
				expired_finished: false,
				expired_loading: false,
				all_page: 1,
				collected_page: 1,
				used_page: 1,
				expired_page: 1,
				flag: true,
                exchange_code: '',
                user_coupons: []

			}
		},
		methods: {
			getjiant(){
                this.GET("api/agreement/maidian?type=Coupon", function (data) {
                if (data.code == 0) {
                    console.log(data);
                }
                });
            },
			getData(data,type){
				var url = "api/userfavor/myvoucher";
				var _self = this;
				this.POST(url,data,function (ret) {
					if(ret.code === 0){

						switch (type) {
							case 'all':
								_self.all_finished = !ret.data.next_page

								if(_self.all_voucher.length <= 0){
									_self.all_voucher = ret.data.coupon_list;
								}else{
									_self.all_voucher = _self.all_voucher.concat(ret.data.coupon_list);
								}
								_self.all_page = ret.data.page;
								_self.all_loading = false;
								break;
							case 'collected':
								_self.collected_finished = !ret.data.next_page;

								if(_self.collected_voucher.length <= 0){
									_self.collected_voucher = ret.data.coupon_list;
								}else{
									_self.collected_voucher = _self.collected_voucher.concat(ret.data.coupon_list);
								}
								_self.collected_page = ret.data.page;
								_self.collected_loading = false;
								break;
							case 'used':
								_self.used_finished = !ret.data.next_page;
								if(_self.used_voucher.length <= 0){
									_self.used_voucher = ret.data.coupon_list;
								}else{
									_self.used_voucher = _self.used_voucher.concat(ret.data.coupon_list);
								}
								_self.used_page = ret.data.page;
								_self.used_loading = false;
								break;
							case 'expired':
								_self.expired_finished = !ret.data.next_page;

								if(_self.expired_voucher.length <= 0){
									_self.expired_voucher = ret.data.coupon_list;
								}else{
									_self.expired_voucher = _self.used_voucher.concat(ret.data.coupon_list);
								}
								_self.expired_page = ret.data.page;
								_self.expired_loading = false;
								break;
						}

					}
					_self.flag  = true;
				})
			},
			getCouponList(type){window.console.log(type)
				var value = 1;
				var page = 1;
				switch (type) {
					case 'all':
						value = 1;
						this.all_loading = true;
						page = this.all_page;
						break;
					case 'collected':
						value = 2;
						this.collected_loading = true;
						page = this.collected_page;
						break;
					case 'used':
						value = 3;
						this.used_loading = true;
						page = this.used_page;
						break;
					case 'expired':
						value = 4;
						this.expired_loading = true;
						page = this.expired_page;
						break;
				}

				var data = {value:value,page:page};
				if(this.flag) {
					this.flag = false;
					this.getData(data, type)
				}

			},
			showCoupon(type){
				switch (type) {
					case 'all':
						if(this.all_voucher.length === 0){
							this.getCouponList(type)
						}
						break;
					case 'collected':
						if(this.collected_voucher.length === 0){
							this.getCouponList(type)
						}
						break;
					case 'used':
						if(this.used_voucher.length === 0){
							this.getCouponList(type)
						}
						break;
					case 'expired':
						if(this.expired_voucher.length === 0){
							this.getCouponList(type)
						}
						break;
				}

			},
            /**
             * 兑换优惠券
             */
            exchangeCode(){
                if(this.exchange_code === ''){
                    this.$toast("Please fill in the exchange code");
                    return false;
                }
                var url = "api/coupon/redeemcoupons";
                var data = {exchange_code:this.exchange_code};
                var _self = this;

                this.POST(url,data,function (data) {
                    if(data.code === 0){
                        _self.user_coupons = data.data.user_coupon;
                    }else{
                        _self.$toast(data.msg)
                    }
                })
            },
		},
	}
</script>